import { type CitationSource } from "@/lib/citation-sources";
import { createContext, useContext } from "react";

export const EMPTY_CITATION_SOURCES: ReadonlyMap<string, CitationSource> =
  new Map();

export const CitationSourcesContext = createContext<
  ReadonlyMap<string, CitationSource>
>(EMPTY_CITATION_SOURCES);

/** The citable pages of the conversation the answer is rendered in. */
export const useCitationSources = (): ReadonlyMap<string, CitationSource> =>
  useContext(CitationSourcesContext);

/**
 * Whether the thread is shown on a phone, read once for every pill of it: a
 * thread holds dozens of pills, and each one listening to the screen size on
 * its own was as many listeners for one value.
 */
export const CitationIsMobileContext = createContext(false);

/** Whether a pill opens its sources in a bottom sheet rather than a popover. */
export const useCitationIsMobile = (): boolean =>
  useContext(CitationIsMobileContext);
